import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "contact-us",
  class: "row"
}
const _hoisted_2 = { class: "col-md-8 offset-md-2" }
const _hoisted_3 = { class: "card mb-4" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "form-row" }
const _hoisted_6 = { class: "col-md-6 form-group" }
const _hoisted_7 = { class: "col-md-6 form-group" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "col-md-6 form-group" }
const _hoisted_10 = { class: "col-md-6 form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-header scenario-field-header" }, "Contact Us", -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { for: "first_name" }, "First Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "first_name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.first_name) = $event)),
                  class: "form-control",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.first_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { for: "last_name" }, "Last Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "last_name",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.last_name) = $event)),
                  class: "form-control",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.last_name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { for: "email" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                  class: "form-control",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { for: "mobile_number" }, "Mobile #", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "mobile_number",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mobile_number) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.mobile_number]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "topicKind" }, "Topic", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.topicKind) = $event)),
                id: "topicKind"
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("option", { value: "general_inquiry" }, "General Inquiry", -1),
                _createElementVNode("option", { value: "live_sp_issue" }, "Live SP/Login Issue", -1),
                _createElementVNode("option", { value: "registering_issue" }, "Signing Up or Registration Issue", -1),
                _createElementVNode("option", { value: "missed_and_reschedule" }, "Missed My SP / Reschedule", -1)
              ]), 512), [
                [_vModelSelect, _ctx.topicKind]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { for: "user_message" }, "Message", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                name: "user_message",
                id: "user_message",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user_message) = $event)),
                rows: "5",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.user_message]
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("button", {
              class: "btn btn-primary float-end",
              type: "submit"
            }, "Submit Form", -1))
          ], 544), [
            [_vShow, _ctx.showForm]
          ]),
          (!_ctx.showForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.message), 1),
                _createElementVNode("div", _hoisted_15, [
                  (!_ctx.showForm)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "mt-2 font-medium text-primary",
                        to: "/dashboard"
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("Return to dashboard >>")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_loading, {
        active: _ctx.loading,
        "is-full-page": true
      }, null, 8, ["active"])
    ])
  ]))
}